<template>
  <BaseModal
    data-cy="pdfGalleryModal"
    :title="title"
    hide-save
    go-back-mode
    @close="() => cancel()"
  >
    <template #cta>
      <ion-buttons class="justify-end">
        <ion-button
          data-cy="downloadResource"
          @click="downloadResources"
        >
          <ion-icon
            slot="icon-only"
            :icon="canShare ? share : download"
          />
        </ion-button>
      </ion-buttons>
    </template>

    <ion-content
      ref="content"
      data-cy="pdfGalleryContent"
    >
      <div class="my-4">
        <div
          v-for="(pdf, key) in pdfs"
          :id="`pdf-${key}`"
          :key="key"
          class="px-4 pt-4"
          :data-cy="`dokument-${key}`"
        >
          <div class="block lg:flex">
            <a-pdf-thumbnail
              :id="`${pdf.name}_${key}`"
              :set-to-max="true"
              :url="getPdfUrl(pdf)"
              :data-cy="`dokument-${key}`"
            /> 
            <ion-button
              v-if="onDelete && !isReadonly"
              fill="clear"
              data-cy="button-delete-dokument"
              @click="onDelete(pdf)"
            >
              <ion-icon :icon="trashOutline" />
            </ion-button>
            <ion-button
              v-if="downloadEnabled"
              color="light"
              class="lg:ml-2"
              @click="() => downloadResource(pdf)"
            >
              <ion-icon
                slot="icon-only"
                :icon="canShare ? share : download"
              />
            </ion-button>
          </div>
        </div>
      </div>
      <div class="my-4">
        <div
          v-for="(photo, key) in imgs"
          :id="`photo-${key}`"
          :key="photo"
          class="px-4 pt-4"
          :data-cy="`photo-${key}`"
        >
          <div class="block lg:flex">
            <a-image
              :src="getPhotoUrl(photo)"
              :image-class="'w-full h-auto'"
              :data-cy="`image-${key}`"
            /> 

            <ion-button
              v-if="downloadEnabled"
              color="light"
              class="lg:ml-2"
              @click="() => downloadResource(photo)"
            >
              <ion-icon
                slot="icon-only"
                :icon="canShare ? share : download"
              />
            </ion-button>
          </div>
          <!-- <ion-button
            v-if="!!allowAddMore"
          >Weitere Fotos hinzufügen
        </ion-button> -->
        </div>
      </div>
    </ion-content>
  </BaseModal>
</template>

<script lang="ts">

import { download, share, addCircleOutline } from "ionicons/icons";
import BaseModal from "@/components/Base/BaseModal";
import useBaseModal from "@/composables/useModal";
import { IonImg, IonContent, IonButtons, IonButton, IonIcon } from "@ionic/vue";
import { trashOutline } from "ionicons/icons";
import { getPhotoUrl, getPdfUrl } from "@/utilities/get-media-url";
import {onMounted, ref} from "vue";
import APdfThumbnail from "@/components/Base/APdfThumbnail";
import useDownloadHelper from "@/composables/useDownloadHelper";
import AImage from "@/components/Base/AImage";

export default {
  name: "PdfGalleryModal",
  components: {APdfThumbnail, AImage, BaseModal, IonImg, IonContent, IonButton, IonButtons, IonIcon },
  props: {
    title: {
      type: String,
      default: ''
    },
    pdfs: {
      type: Array,
      default: undefined
    },
    imgs: {
      type: Array,
      default: undefined
    },
    index: {
      type: Number,
      default: undefined
    },
    onDelete: {
      type: Function,
      default: undefined,
    },
    isReadonly: {
      type: Boolean,
      default: false
    },
    downloadEnabled: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['close', 'save'],
  setup(props: any) {
    const content = ref();
    const { defaultCancel } = useBaseModal();


    const { canShare, downloadFile } = useDownloadHelper();


    async function scrollToIndex() {
      const scrollEl = await content.value.$el.getScrollElement();

      const el = document.getElementById(`photo-${props.index}`)
      scrollEl.scrollTo({ top: el?.offsetTop, behavior: 'smooth' })
    }


    onMounted(async () => {

      setTimeout(() => {
        if (props.index) {
          scrollToIndex();
        }
      }, 700)
      // Monitoring.consoleOnly('pdfs from props: ', props.pdfs);
      // Monitoring.consoleOnly('imgs from props:', props.imgs)
    })

    function downloadResource(pdf: any) {
      downloadFile(""+getPhotoUrl(pdf), pdf.name || 'pdf');
    }

    function downloadResources() {
      props.pdfs.forEach((el: any) => {
        downloadResource(el);
      });
      props.imgs.forEach((el: any) => {
        downloadResource(el);
      });
    }

    return {
      cancel: defaultCancel,
      canShare,
      getPhotoUrl,
      getPdfUrl,
      content,
      trashOutline,
      downloadResource,
      downloadResources,
      download,
      share,
      addCircleOutline,
    }
  }
}
</script>

<style scoped lang="scss">
ion-icon {
  color: var(--white100);
}

ion-button {
  color: var(--white100);
}
</style>